module.exports = __webpack_public_path__ + "vg.7dc61c2052d0dd17b4d8.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/vg.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/vg.svg
// module chunks = styles